import { ArrowUpRight, CalendarDays, Images } from "lucide-react";
import { ProgrammeGallery } from "./components/ProgrammeGallery";
import { SiteFooter, SiteHeader } from "./components/SiteChrome";
import { events, formatEventDateRange } from "./content/editorial";
import { galleryCollections } from "./content/programme-galleries";

export function GalleryPage() {
  const eventAlbums = events
    .filter((event) => event.gallery.length > 0)
    .sort((a, b) => b.startDate.localeCompare(a.startDate));

  return (
    <div className="site-shell editorial-shell" id="top">
      <a className="skip-link" href="#main">Skip to content</a>
      <SiteHeader currentPath="/gallery/" />
      <main id="main">
        <header className="editorial-hero gallery-hero">
          <div className="container editorial-hero-grid">
            <div><p className="overline">The Mission in photographs</p><h1>Gallery</h1></div>
            <p>Glimpses of a living tradition. Learning, spiritual practice and seva.</p>
          </div>
        </header>

        <section className="section gallery-archive" aria-labelledby="programme-gallery-title">
          <div className="container gallery-introduction">
            <h2 className="visually-hidden" id="programme-gallery-title">Living work of the Mission</h2>
            <nav className="collection-links" aria-label="Photo collections"><Images size={18} aria-hidden="true" />{galleryCollections.map((collection) => <a href={`#${collection.slug}`} key={collection.slug}>{collection.title}<span>{collection.slides.length}</span></a>)}</nav>
          </div>

          <div className="container gallery-collections">
            {galleryCollections.map((collection, index) => (
              <article className="gallery-collection" id={collection.slug} key={collection.slug}>
                <header>
                  <span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
                  <div><p className="eyebrow">{collection.kind === "temple" ? "Temple collection" : "Programme collection"} · {collection.slides.length} {collection.slides.length === 1 ? "photograph" : "photographs"}</p><h2>{collection.title}</h2><p>{collection.description}</p></div>
                  <a className="text-link" href={`/#${collection.programmeAnchor}`}>About the {collection.kind === "temple" ? "temple" : "programme"} <ArrowUpRight size={16} aria-hidden="true" /></a>
                </header>
                <ProgrammeGallery title={collection.title} slides={collection.slides} />
              </article>
            ))}
          </div>
        </section>

        {eventAlbums.length > 0 && <section className="section event-albums" aria-labelledby="event-albums-title">
          <div className="container">
            <div className="gallery-introduction">
              <div><p className="eyebrow light">Dated collections</p><h2 id="event-albums-title">Event albums</h2></div>
              <p>Moments from the Mission’s gatherings and celebrations.</p>
            </div>
              <div className="event-album-list">
                {eventAlbums.map((event) => (
                  <article className="event-album" key={event.slug}>
                    <div className="event-album-heading">
                      <div>
                        <p><CalendarDays aria-hidden="true" /> {formatEventDateRange(event)}</p>
                        <h3>{event.title}</h3>
                      </div>
                      <a className="text-link light" href={`/events/${event.slug}/`}>Event details</a>
                    </div>
                    <ProgrammeGallery title={event.title} slides={event.gallery} />
                  </article>
                ))}
              </div>
          </div>
        </section>}
      </main>
      <SiteFooter />
    </div>
  );
}
